import { makeAutoObservable } from 'mobx';
import { component } from 'tsdi';
import { wrapRequest } from 'wrap-request';
import { Api } from './api';
import { injectTSDI } from './tsdi';

@component
export class FeatureStore {
    private api = injectTSDI(Api);
    public featureRequest = wrapRequest(
        (organizationUnitId: number) =>
            this.api.client.ConnectApiFeatureCheckController.getActiveFeatures({
                organizationUnitId
            }),
        { defaultData: [] }
    );

    constructor() {
        makeAutoObservable(this);
    }

    public get isMySportsEnabled() {
        return this.featureRequest.fetched
            ? this.featureRequest.result.includes('MYSPORTS_MESSAGE')
            : false;
    }

    public async init(organizationUnitId: number) {
        await this.featureRequest.request(organizationUnitId);
    }

    public reset() {
        this.featureRequest.reset([]);
    }
}
